import { render, staticRenderFns } from "./editnews.vue?vue&type=template&id=dd6e777c&scoped=true&"
import script from "./editnews.vue?vue&type=script&lang=js&"
export * from "./editnews.vue?vue&type=script&lang=js&"
import style0 from "./editnews.vue?vue&type=style&index=0&id=dd6e777c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6e777c",
  null
  
)

export default component.exports